import jsonpath from 'jsonpath';

/*
|==================================== JSON TO ITEMS ==================================|
|======================      jsonToItems (json, fieldsMap)           =================|
|=====================================================================================|
|   Arguments:
|       - json - is an object that is going to be converted to items
|
|
|       - fieldsMap - this map is an object array that contains field_id and jsonPath to get data from  
|       [
|           {
|               field_id: 431,
|               json_path : "$..item_id"
|           }
|       ]
|
|
|       - Returns items_list:
|      [
|          fields: {
|            field_id: 12356,
|            field_value: "test value"
|          }
|       ]
|
|=====================================================================================|
*/

export function jsonToItems(json, fieldsMap){
    let proccessedMap = [];
    let itemsPath = [];
   
    //-- Step 1 --// 
    // iterating through map and generating list of paths for each field_id
    fieldsMap.forEach( fieldMap =>{
        let json_paths = [];
        try {
            json_paths = jsonpath.paths(json, fieldMap.json_path)
            proccessedMap.push({
                field_id: fieldMap.field_id,
                json_paths: json_paths,
                json_paths_length: json_paths.length,
            });
        } catch (err){
            console.log(err)
        }

    });
  
    //-- Step 2 --//
    // we are sorrting by json_paths_length to find a field with biggest number of json_paths
    // we are going to use the first element of the proccessedMap array as a main iterator
    proccessedMap.sort((b, a) => {
      return a.json_paths_length - b.json_paths_length;
    });
  
  
    //-- Step 3 --//
    // creating items array based on proccessedMap
    let items =  getPathForItems(proccessedMap).map(itemPath => {
      return {  fields : 
             itemPath.fields.map(field => {
              return {
                field_id :  field.field_id,
                field_value : jsonpath.value(json, field.json_path)
              }
            })
      }
    });
  
  
    return items;
  }



  



//**************** BEST MATCH ****************//
// it looks for jsonPath in the pathsToCompare that is mutching the best
function bestMatch(targetPath, pathsToCompare){
    let matchedPaths = [];
    
  
    //-- Creating matchedPaths for compearing targetPath with pathsToCompare
    pathsToCompare.forEach(path =>{
      matchedPaths.push({
        path_to_compare : path,
        match_coefficient : 0
      })
    })
  
  
    //-- Assigning match_coefficient to each path from matchedPaths arrey to determine which path match the best
    // Bigger coefficient means better munch  
    targetPath.forEach( (trgElem, key) => {
      
      for(var i=0; i<matchedPaths.length; i++){
        if(matchedPaths[i].path_to_compare[key] == trgElem){
          matchedPaths[i].match_coefficient += 1/(key+1);
        }
      }
    });
  
  
    //-- Sorting matchedPaths by match_coefficient in order to return puth that match the best
    matchedPaths.sort((b, a) => {
      return a.match_coefficient - b.match_coefficient;
    });
  
    
    //-- Returning first element of matchedPaths[] with biggest match_coefficient with is a best match result
    return matchedPaths[0].path_to_compare;
  }
  
  






  
//*************** GET PATH FOR ITEMS ****************//
/* Here we create array of items those are contains jsonePaths 
/* at the next step we are going to create field_value from json_path
|      [
|            fields:
|            {
|                field_id : 123,
|                json_path : $..test_path
|            }
|        ]
|*/
  function getPathForItems( proccessedMap ){
    let itemsPath = [];

      proccessedMap.length && proccessedMap[0].json_paths.forEach( jsonPath =>{
      let itemPath = {
          fields  : []
      }
  
      proccessedMap.forEach(pMap => {
        itemPath.fields.push({
          field_id : pMap.field_id,
          json_path : bestMatch(jsonPath, pMap.json_paths),
        })
  
      });
      itemsPath.push(itemPath);
    });
  
    return itemsPath;
  }
  
  
  
